import {Entity} from 'app/core/main.entity';
import {HelperService} from '../services/helper.service';
import {plainToInstance, Transform, Type} from 'class-transformer';
import {CustomDate} from '../core/classes/customDate';
import {BlockElementLabel} from './blockElements/blockElementContainer';
import {FileGroupTypes} from './enums';

export class File extends Entity {
  id?: number;

  url: string;

  type?: FileGroupTypes;
  title?: string;
  color?: string;
  extension?: string;

  nativeFile?: any = null;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  dateCreated?: CustomDate;

  source?: string;

  @Type(() => BlockElementLabel)
  label?: BlockElementLabel = null;

  @Type(() => FileThumb)
  thumbnails?: FileThumb[] = [];

  fileUrl?(size: number = null) {
    let url = this.url;
    if (size && this.thumbnails.length) {
      const thumb = this.thumbnails.find(item => item.size === size);
      if (thumb) {
        url = thumb.url;
      }
    }

    return this.getUrl(url);
  }

  downloadUrl?() {
    return this.getDownloadUrl(this.url);
  }

  // @TODO redo for getters
  fileExtension?(): string {
    return this.extension ? this.extension : ((/[.]/.exec(this.url)) ? /[^.]+$/.exec(this.url).pop() : undefined);
  }

  fileName?(): string {
    return this.title ? this.title : ((/[/]/.exec(this.url)) ? /[^/]+$/.exec(this.url).pop() : ((this.url.length) ? this.url : undefined));
  }

  fileType?() {
    if (this.type) {
      return this.type;
    }

    if (HelperService.fileExt(['video']).includes(this.fileExtension())) {
      return 'video';
    }

    if (HelperService.fileExt(['image']).includes(this.fileExtension())) {
      return 'image';
    }

    return 'doc';
  }

  static fromWebApiFile(file: any) {
    const fTemp = plainToInstance(File, {
      id: 0,
      url: URL.createObjectURL(file),
      extension: HelperService.getNativeFileExt(file),
      title: file.name
    });
    fTemp.nativeFile = file;

    return fTemp;
  }
}

export class FileThumb extends Entity {
  size: number;
  url: string;
}
